"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../shared/controllers/BaseController");
var DlgGeneratePromoCodeOperationCtl = /** @class */ (function (_super) {
    __extends(DlgGeneratePromoCodeOperationCtl, _super);
    function DlgGeneratePromoCodeOperationCtl() {
        return _super.call(this, true) || this;
    }
    DlgGeneratePromoCodeOperationCtl.prototype.ResetData = function () {
        this.DATA = {
            onYes: null,
            promo_type_title: "",
            title: "",
            visible: false
        };
    };
    DlgGeneratePromoCodeOperationCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgGeneratePromoCodeOperationCtl.prototype.clearFields = function () {
        this.ResetData();
        return this;
    };
    DlgGeneratePromoCodeOperationCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgGeneratePromoCodeOperationCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    DlgGeneratePromoCodeOperationCtl.prototype.SetOnYesClick = function (callback) {
        this.DATA.onYes = callback;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgGeneratePromoCodeOperationCtl.prototype, "onYesClick", {
        get: function () {
            return this.DATA.onYes;
        },
        enumerable: true,
        configurable: true
    });
    DlgGeneratePromoCodeOperationCtl.prototype.SetTitle = function (title) {
        this.DATA.title = title;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgGeneratePromoCodeOperationCtl.prototype, "Title", {
        get: function () {
            return this.DATA.title;
        },
        enumerable: true,
        configurable: true
    });
    DlgGeneratePromoCodeOperationCtl.prototype.SetPromoTypeTitle = function (title) {
        this.DATA.promo_type_title = title;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgGeneratePromoCodeOperationCtl.prototype, "PromoTypeTitle", {
        get: function () {
            return this.DATA.promo_type_title;
        },
        enumerable: true,
        configurable: true
    });
    return DlgGeneratePromoCodeOperationCtl;
}(BaseController_1.BaseController));
exports.DlgGeneratePromoCodeOperationCtl = DlgGeneratePromoCodeOperationCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ctl/DlgGeneratePromoCodeOperationCtl.ts
// module id = 897
// module chunks = 0